import { useCallback } from 'react';
import { atom, useRecoilState } from 'recoil';
import { ReportableGeoEventType } from 'features/geoEvents/geoEvent.types';
import { Report } from 'features/reports/report.types';

export type SelectedReportForEdit = {
  report: Report;
  geoEventType: ReportableGeoEventType;
  anchorEl: HTMLButtonElement;
};

type UseEditReportActionMenuState = {
  selectedReportForEdit: SelectedReportForEdit | null;
  openEditReportActionMenu: (selected: SelectedReportForEdit) => void;
  closeEditReportActionMenu: () => void;
};

const editReportActionMenuAtom = atom<SelectedReportForEdit | null>({
  key: 'EDIT_REPORT_ACTION_MENU_STATE',
  default: null,
});

export const useEditReportActionMenuState =
  (): UseEditReportActionMenuState => {
    const [selectedReportForEdit, setSelectedReportForEdit] = useRecoilState(
      editReportActionMenuAtom,
    );

    const openEditReportActionMenu = useCallback(
      (selected: SelectedReportForEdit): void => {
        setSelectedReportForEdit(selected);
      },
      [setSelectedReportForEdit],
    );

    const closeEditReportActionMenu = useCallback((): void => {
      setSelectedReportForEdit(null);
    }, [setSelectedReportForEdit]);

    return {
      selectedReportForEdit,
      openEditReportActionMenu,
      closeEditReportActionMenu,
    };
  };
